import { z } from "zod";

const product = z.object({
  id: z.string(),
  offeringId: z.string(),
  offeringName: z.string(), // usuniecie uszkodzenia
});

const totalPrice = z.object({
  grossAmount: z.number(),
});

export const invoice = z.object({
  id: z.string(),
  invoiceNumber: z.string(),
  product: product,
  documentType: z.literal("NOTE").or(z.literal("INVOICE")).optional(),
  invoiceType: z.literal("STANDARD").or(z.literal("CORRECTIVE")),
  invoiceTime: z.string(),
  correctiveInvoiceTime: z.string().optional(),
  invoiceUrl: z.string().optional(),
  totalPrice: totalPrice,
  paymentStatus: z
    .literal("PAID")
    .or(z.literal("NOT_PAID"))
    .or(z.literal("PENDING"))
    .or(z.literal("CORRECTED"))
    .optional(),
});

export const serverResponse = z.object({
  page: z.number(),
  perPage: z.number(),
  total: z.number(),
  invoice: z.array(invoice),
});
